module.exports = __webpack_public_path__ + "img/footer-logos.8d55366a.png";